import React from 'react';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';

const Fortress = window.cccisd && window.cccisd.fortress;

const Course = () => {
    return (
        <DeploymentPlayer
            pawnId={Fortress.user.acting.id}
            pawnHash={Fortress.user.acting.random_hash}
            deploymentHandle="main"
        />
    );
};

export default Course;
